export default __webpack_public_path__ + "locales/fi/PreparationPortal.json?hash=0f6da6682fbdeec5320dd4a5f6f91584";